// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".become-an-author.become-an-author-btn[data-v-77fcae4a]{width:295px}@media (max-width:767px){.become-an-author.become-an-author-btn[data-v-77fcae4a]{width:100%}}", ""]);
// Exports
module.exports = exports;
